import { PermissionFlagModel } from 'api/dto/PermissionFlag.dto';
import { PermissionGroupModel } from 'api/dto/PermissionGroup.dto';
import { PermissionTypesModel } from 'api/dto/PermissionTypes.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'permissions';

export namespace PermissionsState {
  export type PermissionGroupResource = Resource<PermissionGroupModel[]>;

  export type Domain = {
    permissionTypes: PermissionTypesModel;
    permissionGroups: PermissionGroupResource;
    permissionFlags: PermissionFlagModel[];
  };

  export const INITIAL_DOMAIN: Domain = {
    permissionTypes: {
      primary_feature: [],
      feature: [],
      comment_demographic: [],
      comment_department: [],
      summary_demographic: [],
      summary_department: [],
      access: [],
    },
    permissionGroups: Resource.createPendingResource(),
    permissionFlags: [],
  };
}
